import { z } from 'zod'

export const rpLimitFormSchema = z.object({
  name: z.string().nonempty({ message: 'Имя обязательно' }).min(3),
  min: z.preprocess(
    (val) => Number(val),
    z.number().int().positive({ message: 'Значение min должно быть целым положительным числом' })
  ),
  max: z.preprocess(
    (val) => (val === '' ? undefined : Number(val)),
    z.number().int().positive({ message: 'Значение max должно быть целым положительным числом' }).optional()
  ),
  maxPayout: z.preprocess(
    (val) => (val === '' ? undefined : Number(val)),
    z.number().int().positive({ message: 'Значение maxPayout должно быть целым положительным числом' }).optional()
  ),
})

export type TRpLimitFormData = z.infer<typeof rpLimitFormSchema>
